import React from 'react';
import MoreVert from '@mui/icons-material/MoreVert';
import IconMenuButton from 'apollo-react/components/IconMenuButton';
import Tooltip from 'apollo-react/components/Tooltip';
import Settings from '@mui/icons-material/Settings';

const handleClick = (label: any) => () => {
  console.log(`You picked ${label}.`);
};

const menuItems = [
  {
    text: 'Clone',
    onClick: (data: any) => {},
  },
  {
    text: 'Share',
    onClick: handleClick('Share'),
  },
];

export const IconMenuItem = ({ row }: any) => {
  return (
    <Tooltip title='Actions'>
      <IconMenuButton id='actions' menuItems={menuItems} data={row}>
        <MoreVert />
      </IconMenuButton>
    </Tooltip>
  );
};

export const TenantMenuItem = ({ row }: any) => {
  return (
    <Tooltip title='Actions' >
      <IconMenuButton
        id="actions"
        data-testid="actionBtn"
        menuItems={[
          {
            text: 'Change Owner',
            'data-testid': 'changeOnwerBtn',
            onClick: (data: any) => {
              const { index, projectid } = row;
              row.onChangeOwnerClick({ index, projectid });
            },
          }
        ]}
      >
        <MoreVert />
      </IconMenuButton>
    </Tooltip>
  );
};

export const IconMenuHeader = () => {
  return (
    <Settings fontSize='small' style={{ marginTop: 6, marginLeft: 10 }} />
  );
};